import { FormControl } from '@chakra-ui/react';
import { useClassFiltersStore } from '@stores/classes';
import { useListCoaches } from 'hooks/useApiQueries';
import { useCoachStudioParams } from 'hooks/useCoachStudioParams';
import { useLayoutEffect } from 'react';
import { Select } from 'chakra-react-select';
import { ChakraStylesConfig } from 'chakra-react-select';

interface CoachOption {
  label: string;
  value: number;
}

export function ClassesFiltersCoaches() {
  const { data: coaches } = useListCoaches();
  const coachIds = useClassFiltersStore((state) => state.coachIds);
  const setCoachIds = useClassFiltersStore((state) => state.setCoachIds);

  const { isCoachUrl, id } = useCoachStudioParams();
  useLayoutEffect(() => {
    if (isCoachUrl) setCoachIds([id]);
  }, [isCoachUrl, id, setCoachIds]);

  const options: CoachOption[] =
    coaches
      ?.filter((coach) => {
        if (!mondayMindbody?.siteId) return true;
        return mondayMindbody.siteId === String(coach.SiteId);
      })
      .sort((previous, next) => previous.FirstName.localeCompare(next.FirstName))
      .map((coach) => ({ label: coach.FirstName, value: coach.Id })) ?? [];

  const values = options.filter((option) => coachIds.includes(option.value));

  const chakraStyles: ChakraStylesConfig<CoachOption, true> = {
    container: (provided) => ({
      ...provided,
      minWidth: '200px',
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      borderColor: 'gray.200',
      _hover: {
        borderColor: 'primary.500',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'primary.500' : 'white',
      color: state.isSelected ? 'white' : 'gray.700',
      _hover: {
        backgroundColor: state.isSelected ? 'primary.600' : 'gray.100',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'primary.100',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'primary.700',
    }),
  };

  return (
    <FormControl>
      <Select<CoachOption, true>
        size="sm"
        isMulti
        name="coaches"
        options={options}
        placeholder="Sélectionner un ou plusieurs coaches"
        closeMenuOnSelect={false}
        value={values}
        onChange={(options) => {
          const selectedIds = options ? options.map((option) => option.value) : [];
          setCoachIds(selectedIds);
        }}
        chakraStyles={chakraStyles}
      />
    </FormControl>
  );
}
